import { Injectable } from '@angular/core';
import { LocalStorageService } from '@shared/utils/services';
import { Observable } from 'rxjs';
import { PaymentDao } from '@cart-checkout/data-access/dao';
import { PaymentMethod } from '@cart-checkout/checkout/data-access/interfaces';

@Injectable({
	providedIn: 'root'
})
export class PaymentService {

	constructor(private paymentDao: PaymentDao, private localStorageService: LocalStorageService) { }

	getPaymentsScriptConfig(configURL: string): Observable<any> {
		return this.paymentDao.getPaymentsScriptConfig(configURL);
	}

	getAfterPayScriptConfig(): Observable<any> {
		return this.paymentDao.getAfterPayScriptConfig();
	}

	storePaymentMethodsInLocalStorage(paymentMethods: PaymentMethod[], checkoutKey: string) {
		if (!paymentMethods || paymentMethods.length === 0) return;

		// Remove gift card payment methods from the list
		paymentMethods = paymentMethods.filter((paymentMethod) => !paymentMethod.paymentMethod.includes('giftCard'));

		if (paymentMethods.length === 0) return;

		// Remove accountSummary from payment methods
		for (const paymentMethod of paymentMethods) {
			delete paymentMethod.accountSummary;
		}

		const paymentMethod = {
			checkoutKey: checkoutKey,
			...paymentMethods[0]
		};

		this.localStorageService.set('paymentMethod', JSON.stringify(paymentMethod));
	}
}
